module.exports = __webpack_public_path__ + "static/media/banner003-a.905373a8.jpg";